export const FeatureFlag = {
  UpdateEnabled: false,
  DeleteMessageHistoryTalk: false,
  ToggleChatSearch: false,
  Docs: true,
  Analytics: true,
};
